/* eslint-disable */
export default {
  allCalls: 'すべての通話',
  Unknown: '不明',
  Multiple: '複数',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
